import React, { useState } from "react";
import { Button, Modal, TimePicker, Spin } from "antd";
import { ImCross } from "react-icons/im";
import { ThreeCircles } from "react-loader-spinner";

const OrderConfirmationModel = ({ handleCnfCancel, showLoader,spinning }) => {


  return (
    <>
      <Spin
        // percent={percent}
        spinning={spinning}
        indicator={
          <ThreeCircles
            visible={true}
            height="100"
            width="100"
            color="#4fa94d"
            ariaLabel="three-circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        }
        fullscreen
      />
      <div className="order_cnf_container">
        <span className="iconbox" onClick={() => handleCnfCancel(false)}>
          <ImCross className="cross_design" />
        </span>
        <div className="cnf_model_header">
          <div className="md_cnf_box">
            <h4>Order Confirmation</h4>
          </div>
        </div>
        <div className="predection_container">
          <div className="main_pred_conta">
            <div className="predection_container_left">
              <h6>Predaction Time</h6>
              <TimePicker style={{ width: "30vh", cursor: "pointer" }} />
            </div>
            <div className="predection_container_right">
              <Button
                className="confirm_btn btn_apt"
                //   loading={cnfloading}
                onClick={showLoader}
              >
                Add Preparation Time
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderConfirmationModel;
